/**
 * Attestation legal texts used across pet registration and no-pet declaration flows.
 * All attestations require explicit checkbox acknowledgment before submit.
 */

/** Attestation title for pet registration */
export const PET_REGISTRATION_ATTESTATION_TITLE = 'Resident Attestation & Authorization';

/** Attestation text for pet registration (Step 6 - Review & Attestation) */
export const PET_REGISTRATION_ATTESTATION_TEXT =
  "I confirm all details I provided are accurate and will keep the information updated. I understand and agree to the property's pet policies and fees. I understand the $25 registration fee is non-refundable. I allow the property and GetPawtected to verify my pet's details with my veterinarian and use the information per their Terms and Privacy Policy. I understand false information may lead to denial, lease termination, or lease violation fees. By submitting, I agree to all terms above.";

/** Attestation title for no-pets declaration */
export const NO_PET_ATTESTATION_TITLE = 'No-Pet Resident Attestation';

/** Attestation text for no-pets declaration */
export const NO_PET_ATTESTATION_TEXT =
  "I confirm my information is accurate and that I currently do not have any pets/animals. I understand I must notify the property and complete screening if I get a pet/animal at a future date. I understand false information may lead to lease termination or lease violation fees. I allow GetPawtected to use this information per their Terms and Privacy Policy. By submitting, I agree to all terms above.";

/** Build attestation payload for submissions (timestamp, signature, full text) */
export interface AttestationData {
  attested_at: string; // ISO timestamp
  attestation_text: string;
  signature?: string; // e.g. "Name (email)" or user identifier
}

export function buildAttestationData(
  fullText: string,
  signature?: string
): AttestationData {
  return {
    attested_at: new Date().toISOString(),
    attestation_text: fullText,
    ...(signature ? { signature } : {}),
  };
}
